export default __webpack_public_path__ + "media/images/table_2-f1227ba733d5d2beee8d60494884a3c1.png";